<template>
  <page-layout :title="categoryData.categoryNm" class="allow-contextmenu">
    <template v-slot:content>
      <div class="board-detail-layout">
        <div class="route-board-category-table">
          <v-btn class="button" outlined @click="routePage('table')">게시글 목록 이동</v-btn>
          <v-btn class="button" outlined @click="routePage('main')">게시판 메인 이동</v-btn>
        </div>
        <div class="board-header-layout">
          <div class="board-detail-title">
            <span class="board-title">{{ boardData.title }}</span>
          </div>
          <div class="board-detail-info-layout">
            <div class="board-detail-info">
              <span class="board-detail-text">게시자 : {{ boardData.createNm }}</span>
            </div>
            <div class="board-detail-info">
              <span class="board-detail-text">게시일 : {{ setTableDateFormat(boardData.createDate) }}</span>
              <span class="board-detail-text">조회 {{ boardData.viewCnt }}</span>
            </div>
          </div>
        </div>
        <div class="board-images-layout">
          <div class="board-images" v-for="(src, index) in previews" :key="index + '_image'">
            <img class="board-image allow-contextmenu allow-drag" v-if="src" :src="src" alt="" draggable="true" type="image/jpeg" />
          </div>
        </div>
        <div class="border-content-layout">
          <div class="border-content allow-drag">
            {{ boardData.content }}
          </div>
        </div>
        <div class="border-bottom-layout">
          <div class="input-files-layout">
            <v-icon class="input-file-icon">mdi-paperclip</v-icon>
            <div class="input-files" v-if="files.length > 0">
              <span class="input-file" v-for="(file, index) in files" :key="index" @click="getFileData(file, 'download')">
              {{ (file.fileNm + "." + file.fileType) }}
              </span>
            </div>
            <div v-else>
              <span>파일이 없습니다.</span>
            </div>
          </div>
          <div v-if="isWriter" class="buttons-layout">
            <v-btn class="button" outlined @click="modifyBoard">게시글 수정</v-btn>
            <v-btn class="button" outlined @click="deleteBoard">게시글 삭제</v-btn>
          </div>
        </div>
      </div>
    </template>
  </page-layout>
</template>

<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import {axiosInstance} from "@/util/AxiosModule";
import router from "@/router";
import {mapGetters} from "vuex";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "BoardDetail",
  components: {PageLayout},
  mixins: [DateMixin],
  data() {
    return {
      categoryData: {},
      boardData: {},
      files: [],
      previews: []
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      memberRole: "memberRole"
    }),
    isWriter() {
      return this.memberRole === "ADMIN" || (this.memberId === this.boardData.createId);
    },
  },
  mounted() {
    this.categoryData = JSON.parse(sessionStorage.getItem("boardDetailList"));
    const boardDetail = JSON.parse(sessionStorage.getItem("boardDetail"));
    this.getBoardDetailData(boardDetail.boardId);
  },
  methods: {
    async getBoardDetailData(boardId) {
      this.files = [];
      this.previews = [];
      const { data } = await axiosInstance.get("/private/board/board", {
        params: {
          boardId: boardId
        }
      });
      if (data) {
        this.boardData = data.board;
        for (const file of data.files) {
          if (file.fileType !== "png" && file.fileType !== "jpeg" && file.fileType !== "jpg") {
            this.files.push(file);
          } else {
            await this.getFileData(file, 'preview');
          }
        }
      }
    },
    async getFileData(file, type) {
      await axiosInstance.get("/private/board/board-file", {
        responseType: 'blob',
        params: {
          fileKey: file.fileKey
        }
      }).then((response) => {
        if (type === "download") {
          this.downloadFile(response.data, file);
        } else if (type === 'preview') {
          this.showImageFromBlob(response.data);
        }
      }).catch((error) => {
        this.showAlert({message: `${error.response.data.message}`});
      })
    },
    downloadFile(blob, fileData) {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileData.fileNm + "." + fileData.fileType;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    showImageFromBlob(blob) {
      const file = new File([blob], "download.jpg", {type: "image/jpeg"});
      const imageUrl = URL.createObjectURL(file);
      this.previews.push(imageUrl);
    },
    modifyBoard() {
      router.push({name: "BoardModify", params: {boardId: this.boardData.boardId}});
    },
    deleteBoard() {
      this.showConfirm({
        message: "해당 게시물을 삭제하시겠습니까?",
        successCallback: () => {
          this.delete();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async delete() {
      await axiosInstance.delete("/private/board/board", {
        params: {
          boardId: this.boardData.boardId,
          memberId: this.memberId
        }
      }).then(() => {
        this.showAlert({
          message: "게시물이 삭제 완료되었습니다.",
          successCallback: () => {
            router.push({name: "BoardTable", params: {categoryId: this.categoryData.categoryId}});
          }
        })
      })
    },
    routePage(type) {
      if (type === "table") {
        router.push({ name: "BoardTable", params: {categoryId: this.categoryData.categoryId}});
      }
      if (type === "main") {
        router.push({ name: "BoardMain" });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Board/BoardDetail.scss";
</style>